import React from "react";
import vineyardImg from "../assets/vineyard-village.png";
import vasaiImg from "../assets/vasai-cellar.png";

const About = () => {
  return (
    <section className="bg-[--neutral-light-gray] py-20 px-6">
      <div className="max-w-6xl mx-auto space-y-24">
        {/* HEADER */}
        <div className="text-center space-y-4">
          <h1 className="text-4xl sm:text-5xl font-extrabold text-[--primary-wine]">
            The Legacy of the Carneiro Family
          </h1>
          <p className="text-lg text-gray-700 max-w-3xl mx-auto">
            Over five decades of tradition, taste, and timeless winemaking.
          </p>
        </div>

        {/* SECTION 1: 1969 - The Spark */}
        <div className="grid md:grid-cols-2 gap-10 items-center">
          <img
            src={vineyardImg}
            alt="Portuguese Vineyard"
            className="rounded-xl shadow-md w-full object-cover h-[320px]"
          />
          <div className="space-y-4">
            <h2 className="text-2xl sm:text-3xl font-bold text-[--primary-wine]">
              1969 – The Spark in Portugal
            </h2>
            <p className="text-gray-700 text-base leading-relaxed">
              In the summer of 1969, Victor Carneiro was inspired by his grandfather’s wisdom to
              begin crafting small batches of fruit wine in a serene Portuguese village. Using
              locally grown fruits, wheat, and a secret spice blend, he perfected a formula later
              known as <strong>“Ronnie’s Secret Wine.”</strong>
            </p>
            <p className="text-sm italic text-gray-500">
              “The aroma of that first barrel still lives in our memory.”
            </p>
          </div>
        </div>

        {/* SECTION 2: A Generational Passion */}
        <div className="bg-white shadow-xl rounded-xl p-6 md:p-12 border-l-4 border-[--accent-gold] space-y-6">
          <h2 className="text-2xl font-bold text-[--primary-wine]">
            A Generational Passion Continues 🍇
          </h2>
          <p className="text-gray-700 text-base leading-relaxed">
            Through the 1980s and 90s, Victor’s children didn’t just watch—they took part. Each
            generation learned the craft, elevating family techniques while preserving its soul.
            Their efforts turned the once-humble wine into a symbol of celebration across weddings,
            festivals, and generations.
          </p>
          <div className="grid md:grid-cols-3 gap-6 pt-4">
            <div>
              <h4 className="font-semibold text-[--primary-wine-light] mb-1">
                🌿 Innovative Flavors
              </h4>
              <p className="text-sm text-gray-700">
                Tropical wines from mango, beetroot, chikku & jamun — all fermented with a classic
                herbal twist.
              </p>
            </div>
            <div>
              <h4 className="font-semibold text-[--primary-wine-light] mb-1">
                🌱 Eco Practices
              </h4>
              <p className="text-sm text-gray-700">
                Sustainable brewing with glass bottles, natural yeasts, and low-waste fermentation.
              </p>
            </div>
            <div>
              <h4 className="font-semibold text-[--primary-wine-light] mb-1">
                🧡 Knowledge Transfer
              </h4>
              <p className="text-sm text-gray-700">
                Children and grandchildren trained hands-on — from crushing grapes to corking
                bottles.
              </p>
            </div>
          </div>
          <p className="italic text-sm text-gray-500 pt-4">
            “What began as Victor’s dream, now lives in every bottle, passed from hand to hand,
            heart to heart.”
          </p>
        </div>

        {/* SECTION 3: Today in Vasai */}
        <div className="grid md:grid-cols-2 gap-10 items-center">
          <img
            src={vasaiImg}
            alt="Vasai Wine Cellar"
            className="rounded-xl shadow-md w-full object-cover h-[320px]"
          />
          <div className="space-y-4">
            <h2 className="text-2xl sm:text-3xl font-bold text-[--primary-wine]">
              Today in Vasai, Maharashtra
            </h2>
            <p className="text-gray-700 text-base leading-relaxed">
              What began in Portugal now flourishes in Vasai, India. The Carneiro family handcrafts
              fruit wines using mangoes, grapes, jamun, and local herbs — blending tradition with
              modern methods, in small, soulful batches.
            </p>

            <div className="grid grid-cols-2 gap-4 text-sm text-gray-700 pt-2">
              <div>
                <h4 className="font-semibold text-[--primary-wine-light] mb-1">
                  Batch Volume
                </h4>
                <p>100–150 bottles per batch</p>
              </div>
              <div>
                <h4 className="font-semibold text-[--primary-wine-light] mb-1">
                  Varieties
                </h4>
                <p>Mango, Grape, Beetroot, Chikku, Jamun</p>
              </div>
              <div>
                <h4 className="font-semibold text-[--primary-wine-light] mb-1">
                  Philosophy
                </h4>
                <p>Craft. Culture. Celebration.</p>
              </div>
              <div>
                <h4 className="font-semibold text-[--primary-wine-light] mb-1">
                  Craft Method
                </h4>
                <p>Natural fermentation, herbal infusion</p>
              </div>
            </div>
          </div>
        </div>

        {/* CLOSING QUOTE */}
        <div className="text-center border-t border-gray-300 pt-10">
          <p className="italic text-lg text-[--primary-wine-light] max-w-3xl mx-auto">
            “Each bottle tells a story of love, tradition, and the enduring spirit of the Carneiro
            family.”
          </p>
        </div>
      </div>
    </section>
  );
};

export default About;
